import { Node } from '@tiptap/core'

export const Attachment = Node.create({
  name: 'attachment',
  group: 'block',
  atom: true,
  draggable: true,
  selectable: true,
  
  addAttributes() {
    return {
      href: {
        default: null,
      },
      title: {
        default: null,
      },
      filename: {
        default: null,
      },
      size: {
        default: 0,
      },
      contentType: {
        default: null,
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'div.attachment-wrapper',
        priority: 100,
        getAttrs: element => {
          console.log('Parsing attachment wrapper from HTML:', element)
          const link = element.querySelector('a.attachment')
          if (!link) {
            console.log('No attachment link found in wrapper')
            return false
          }
          const title = link.getAttribute('data-title')
          const filename = link.getAttribute('data-filename')
          const attrs = {
            href: link.getAttribute('href') || '',
            title: title || filename || link.textContent || '',
            filename: filename || '',
            size: parseInt(link.getAttribute('data-size') || '0', 10),
            contentType: link.getAttribute('data-content-type') || '',
          }
          console.log('Parsed attachment attrs:', attrs)
          return attrs
        },
      },
      {
        tag: 'a[class~=attachment]',
        priority: 90,
        getAttrs: element => {
          console.log('Parsing attachment link from HTML (fallback):', element)
          const title = element.getAttribute('data-title')
          const filename = element.getAttribute('data-filename')
          const attrs = {
            href: element.getAttribute('href') || '',
            title: title || filename || element.textContent || '',
            filename: filename || '',
            size: parseInt(element.getAttribute('data-size') || '0', 10),
            contentType: element.getAttribute('data-content-type') || '',
          }
          console.log('Parsed attachment attrs (fallback):', attrs)
          return attrs
        },
      },
    ]
  },

  renderHTML({ node }) {
    // Renderování pro ukládání - obalíme do div.attachment-wrapper pro spolehlivé parsování
    const title = node.attrs.title || node.attrs.filename || 'Příloha'
    const filename = node.attrs.filename || ''
    const href = node.attrs.href || '#'
    const size = node.attrs.size || 0
    const contentType = node.attrs.contentType || ''
    
    console.log('renderHTML - saving attachment:', { title, filename, href, size, contentType })
    
    return [
      'div',
      { 
        class: 'attachment-wrapper',
        'data-type': 'attachment'
      },
      [
        'a',
        {
          href: href,
          class: 'attachment',
          download: filename,
          target: '_blank',
          'data-title': title,
          'data-filename': filename,
          'data-size': String(size),
          'data-content-type': contentType,
        },
        title,
      ]
    ]
  },

  addCommands() {
    return {
      insertAttachment:
        (attrs) =>
        ({ chain }) => {
          return chain()
            .insertContent({
              type: this.name,
              attrs,
            })
            .run()
        },
    }
  },

  addNodeView() {
    return ({ node }) => {
      const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 B'
        const k = 1024
        const sizes = ['B', 'KB', 'MB', 'GB']
        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`
      }

      const updateContent = (node) => {
        console.log('Attachment updateContent - raw attrs:', node.attrs)
        const displayTitle = node.attrs.title || node.attrs.filename || 'Příloha'
        
        console.log('Attachment updateContent - displayTitle:', displayTitle)
        
        // Update content text
        content.textContent = displayTitle
        
        // Update size
        if (node.attrs.size) {
          sizeSpan.textContent = formatFileSize(node.attrs.size)
          sizeSpan.style.display = ''
        } else {
          sizeSpan.style.display = 'none'
        }
        
        // Update link attributes
        link.href = node.attrs.href || '#'
        link.download = node.attrs.filename || ''
        link.setAttribute('data-title', node.attrs.title || '')
        link.setAttribute('data-filename', node.attrs.filename || '')
        link.setAttribute('data-size', node.attrs.size || 0)
        link.setAttribute('data-content-type', node.attrs.contentType || '')
      }

      const wrapper = document.createElement('div')
      wrapper.className = 'attachment-wrapper'
      
      const link = document.createElement('a')
      link.className = 'attachment'
      link.target = '_blank'
      
      // Icon SVG
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      icon.setAttribute('width', '20')
      icon.setAttribute('height', '20')
      icon.setAttribute('viewBox', '0 0 24 24')
      icon.setAttribute('fill', 'none')
      icon.setAttribute('stroke', 'currentColor')
      icon.setAttribute('stroke-width', '2')
      
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
      path.setAttribute('d', 'M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z')
      icon.appendChild(path)
      
      const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline')
      polyline.setAttribute('points', '13 2 13 9 20 9')
      icon.appendChild(polyline)
      
      link.appendChild(icon)
      
      // Content container
      const content = document.createElement('div')
      content.className = 'attachment-content'
      link.appendChild(content)
      
      // Size span
      const sizeSpan = document.createElement('span')
      sizeSpan.className = 'attachment-size'
      link.appendChild(sizeSpan)
      
      wrapper.appendChild(link)
      
      // Initial update
      updateContent(node)
      
      return {
        dom: wrapper,
        update: (updatedNode) => {
          if (updatedNode.type !== node.type) {
            return false
          }
          updateContent(updatedNode)
          return true
        }
      }
    }
  },
})

